import React, { useCallback, useRef } from "react"
import FullCalendar from "@fullcalendar/react"
import dayGridPlugin from "@fullcalendar/daygrid"
import timeGridPlugin from "@fullcalendar/timegrid"
import interactionPlugin from "@fullcalendar/interaction"
import { eventTypesTexts } from "../../utils/requests/events.js"
import { useAtom } from "jotai"
import { settingsAtom } from "../../utils/atoms"
import heLocale from "@fullcalendar/core/locales/he"
import { useNavigate } from "react-router-dom"

export default function Calendar({ events, setEvents, loadEvents }) {
  const [settings] = useAtom(settingsAtom)
  const calendarRef = useRef(null)
  const navigate = useNavigate()

  const userDep = settings?.user?.id

  // Called when the calendar view changes
  const handleDatesSet = useCallback(
    (arg) => {
      loadEvents(arg.start, arg.end)
    },
    [loadEvents],
  )

  function handleDateSelect(selectInfo) {
    // let title = prompt('Please enter a new title for your event')
    // let calendarApi = selectInfo.view.calendar
    // calendarApi.unselect()
    // if (title) {
    //     calendarApi.addEvent({
    //         id: createEventId(),
    //         title,
    //         start: selectInfo.startStr,
    //         end: selectInfo.endStr,
    //         allDay: selectInfo.allDay
    //     })
    // }
  }

  function handleEventClick(clickInfo) {
    navigate(`/event-details/${clickInfo.event.id}`)
  }

  // Calculate dynamic slotDuration and slotMinTime
  let slotDuration = "00:20:00"
  let slotMinTime = "06:00:00"
  if (settings?.teacher?.lessonDuration) {
    const mins = settings.teacher.lessonDuration
    const hours = Math.floor(mins / 60)
      .toString()
      .padStart(2, "0")
    const minutes = (mins % 60).toString().padStart(2, "0")
    slotDuration = `${hours}:${minutes / 2}:00`
  }
  if (Array.isArray(settings?.workingHour) && settings.workingHour.length > 0) {
    // Find the earliest startTime among all workingHour entries
    let minStart = settings.workingHour.reduce((min, wh) => {
      const [h, m] = wh.startTime.split(":").map(Number)
      const total = h * 60 + m
      return total < min ? total : min
    }, 24 * 60)
    const minHour = Math.floor(minStart / 60)
      .toString()
      .padStart(2, "0")
    const minMinute = (minStart % 60).toString().padStart(2, "0")
    slotMinTime = `${minHour}:${minMinute}:00`
  }

  if (!userDep) {
    return null
  }
  return (
    <div className="demo-app">
      <div className="demo-app-main">
        <FullCalendar
          ref={calendarRef}
          plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
          headerToolbar={{
            left: "title",
            center: "timeGridDay,timeGridWeek,dayGridMonth",
            right: "prev,next today",
          }}
          initialView="timeGridWeek"
          locale={heLocale}
          buttonText={{
            today: "היום",
            month: "חודש",
            week: "שבוע",
            day: "יום",
            list: "רשימה",
          }}
          editable={false}
          selectable={true}
          selectMirror={true}
          weekends={true}
          expandRows
          events={events}
          select={handleDateSelect}
          eventContent={renderEventContent}
          eventClick={handleEventClick}
          datesSet={handleDatesSet}
          slotDuration={slotDuration}
          slotMinTime={slotMinTime}
          slotLabelFormat={{ hour: '2-digit', minute: '2-digit', hour12: false }}
          slotLabelInterval={slotDuration}
        />
      </div>
    </div>
  )
}

function renderEventContent(eventInfo) {
  console.log(eventInfo.view.type)
  return (
    <>
      {eventInfo.view.type === "dayGridMonth" && !eventInfo.event.allDay && (
        <b>
          {new Date(eventInfo.event.start).toLocaleTimeString("he-IL", {
            hour: "numeric",
            minute: "2-digit",
          })}
        </b>
      )}
      <i>{eventInfo.event.title}</i>
      {eventInfo.view.type === "dayGridMonth" &&
        !!eventInfo.event.extendedProps.count && (
          <>
            <i class="onlypopover">
              {eventTypesTexts[eventInfo.event.extendedProps.type]}
            </i>
            <i class="onlypopover">מספר</i>
            <i class="onlypopover">{eventInfo.event.extendedProps.count}</i>
          </>
        )}
      {eventInfo.view.type === "timeGridDay" &&
        !!eventInfo.event.extendedProps.count && (
          <>
            <i>{eventTypesTexts[eventInfo.event.extendedProps.type]}</i>
            <i>מספר</i>
            <i>{eventInfo.event.extendedProps.count}</i>
          </>
        )}
    </>
  )
}
